import API_URL from '../../constants/API_URL'
import { message } from 'antd'
const axios = require('axios')

export const SCREENS = 'SCREEENS'
export const SCREENS_PROGRESS = 'SCREEENS_PROGRESS'
export const SCREENS_BY_ID = 'SCREENS_BY_ID'
export const SCREENS_BY_ID_PROGRESS = 'SCREENS_BY_ID_PROGRESS'

const screensAction = data => ({
  type: SCREENS,
  data
})
const screenByIDAction = data => ({
  type: SCREENS_BY_ID,
  data
})
  export const screens = payload => dispatch => {
    dispatch({ type: SCREENS_PROGRESS })
    let authOptions = {
      url: API_URL + 'screens',
      method: 'get',
      params: payload.params,
      headers: {
        'Authorization': payload.tokenType + ' ' + payload.accessToken,
        'Content-Type': 'application/json'
      }
    }
    axios(authOptions)
      .then((res) => {
        const pagination = { ...payload.pagination };
        pagination.total = res.data.totalElements;
        pagination.current = payload.params.page +1;

        let data = {
          loading: false,
          data: res.data.content,
          pagination,
        }
        dispatch(screensAction(data))
      })
      .catch(err => {
        dispatch(screensAction({ loading: false, err:err }))
      })
  }

export const deleteScreen = payload => async dispatch => {
  let authOptions = {
    url: API_URL + 'deleteScreen',
    method: 'POST',
    data: payload.data,
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  }
  await axios(authOptions)
    .then((res) => {
      message.success(res.data.message);
    }).catch((err) => {

    });
}

export const createScreen = payload => async dispatch => {
  var authOptions = {
    method: 'POST',
    url: API_URL + 'createScreen',
    data: payload.data,
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  };
  await axios(authOptions)
    .then(function (response) {
      if (response.data.success === true) {
        message.success(response.data.message);
      } else if (response.data.success === false) {
        message.error(response.data.message)
      }

    })
    .catch(function (error) {
      //message.error(error.response.data.message);    
    });
}
export const updateScreen = payload => async dispatch => {
  var authOptions = {
    method: 'POST',
    url: API_URL+'updateScreen',
    data: payload.data,
    headers: {
         'Authorization': payload.tokenType+' '+payload.accessToken,
        'Content-Type': 'application/json'
    }
  };
  axios(authOptions)
  .then(function (response) {
    if(response.data.success===true){
    message.success(response.data.message)
    }else if(response.data.success===false){
      message.error(response.data.message)
    }

     })
  .catch(function (error) {
//message.error(error.response.data.message);
    
  });
}

export const screenByID = payload => async dispatch => {
  var authOptions = {
    method: 'GET',
    url: API_URL+'screenByID',
    params: payload.params,
    headers: {
         'Authorization': payload.tokenType+' '+payload.accessToken,
        'Content-Type': 'application/json'
    }
  };
 await  axios(authOptions)
  .then(function (response) {
    if(response.data.success===true){
    message.success(response.data.message);
        dispatch(screenByIDAction(response.data.object))
    }else if(response.data.success===false){
      message.error(response.data.message)
    }
     })
  .catch(function (error) {
    dispatch(screenByIDAction(error))
  });
}